export const environment = {
    production: false,
    api_endpoint: 'http://localhost:8080',

    buildCommitId: '0037c14b',
    buildDate: '15.09.2026 14:27:57'
};
